export var getOrdinalSuffix = function getOrdinalSuffix(num) {
  var pluralRule = new Intl.PluralRules('en-GB', {
    type: 'ordinal'
  });
  var suffixes = {
    one: 'st',
    two: 'nd',
    few: 'rd',
    other: 'th'
  };
  return suffixes[pluralRule.select(num)];
};
export var isNumber = function isNumber(val) {
  return Number.isInteger(Number(val));
};
export var isBetween = function isBetween(val, start, end) {
  return val >= start && val <= end;
};